<template v-editable="blok">
  <BaseButton
    :title="blok.text"
    :href="blok.link"
    link
    :target="blok.link && blok.link.target"
    :link-secondary="blok.is_color_secondary"
    :style="colorStyle"
  >
    <template #text>
      {{ blok.text }}
    </template>
    <template v-if="blok.icon && blok.icon.filename" #icon>
      <img
        width="16"
        height="16"
        :src="blok.icon && blok.icon.filename"
        :alt="blok.icon && blok.icon.alt"
      />
    </template>
  </BaseButton>
</template>

<script lang="ts" setup>
import type { SbButtonLinkStoryblok } from '@/types'

interface Props {
  blok: SbButtonLinkStoryblok
}

const props = defineProps<Props>()

const colorStyle = computed(() => {
  const c = props.blok.color?.value
  if (!c) return undefined
  return {
    color: c,
    '--btn-link-color': c,
    '--btn-link-hover-color': c,
  }
})
</script>
